
'use client';

import React, { useState, useRef, useEffect } from 'react';
import { useTranslations } from "next-intl"
import { IoMdCloseCircle } from "react-icons/io";
import {useLocale} from 'next-intl';
import Image from 'next/image';
const SafeDialog: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dialogRef = useRef<HTMLDivElement>(null); // Ref for the dialog container
  const t = useTranslations('Shop-id');
  const l = useLocale();
 



 
  // Close the dialog when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
        setIsOpen(false); // Close the dialog
      }
    };

    // Add event listener when the dialog is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]); // Re-run effect when `isOpen` changes

  return (
    <>
      {/* Button to open the dialog */}
      <p
        className="underline text-gray-800 cursor-pointer hover:text-blue-500 select-none"
        onClick={() => setIsOpen(true)}
      >
        {t('secure link')}
      </p>


      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
         <div
            ref={dialogRef} // Attach the ref to the dialog container
            className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative space-y-4"
          >
            {/* Close Button */}
            {l === 'ar' ? (
              <IoMdCloseCircle
                size={24}
                className="absolute top-2 left-2 text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={() => setIsOpen(false)}
              />
            ) : (
              <IoMdCloseCircle
                size={24}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={() => setIsOpen(false)}
              />
            )}

            {/* Content */}
            <h1 className="text-xl font-semibold uppercase">{t('secure title')}</h1>
            <p className="text-gray-600 text-sm">
            {t('secure description')}
            </p>

          

        </div>
        </div>
      )}
    </>
  );
};

export default SafeDialog;
